export const endpoints = {
  userStatistics: "/stats/datasets/user",
  userExecustions: "/stats/executions/user",
  orgExecustions: "/stats/executions/org",
  orgStatistics: "/stats/datasets/org",
  resources: "/stats/resources",
  deployODModel: "/cameras/models",
  // Camera //
  testCamera: "/cameras/test",
  testConnection: "/connection/:protocolType/test",
  cameraPushImage: "/cameras/push_test_image",
  testCameraConfig: "/cameras/test_configuration",
  // Model Deployment //
  deployModel: "/models/v2/:id/deploy",
  deleteDeployedModel: "/models/v2/:id/deploy",
  checkDeployedModel: "/models/v2/:id/is-deployed",
  checkDeployModelLimit: "/models/v2/deployed/limit",
  servableModelsList: "/models/v2/deployed",
  deleteCameraModelConnection: "/cameras/remove_connection/:id",
  predictByDateScheduledExec: "/scheduledExecution/run/:id",
  daysToLookBackScheduledExec: "/scheduledExecution/:id/days_to_look_back",
  // Prediction Feedback //
  feedbackProjects: "/datasets/:id/feedback_projects",
  feedbackProjectsMonitors: "/monitors/:id/feedback_projects",
  pushFeedbackImg: "/datasets/:id/feedback_projects/:project_id/push_image",
  monitorAnalytics: {
    generalInfo: "/hoya/v2/monitors/:id/analytics/general",
    judgementPerSide: "/hoya/v2/monitors/:id/analytics/judgement_per_side",
    labelsPerSide: "/hoya/v2/monitors/:id/analytics/labels_per_side",
    defectLocations: "/hoya/v2/monitors/:id/analytics/defects-locations",
    judgementPerImage: "/hoya/v2/monitors/:id/analytics/judgement_per_image",
  },
  dataSourceAnalytics: {
    generalInfo: "/hoya/v3/monitor/:id/analytics/general",
    judgementPerSide: "/hoya/v3/monitor/:id/analytics/judgement_per_side",
    labelsPerSide: "/hoya/v3/monitor/:id/analytics/labels_per_side",
    defectLocations: "/hoya/v3/monitor/:id/analytics/defects-locations",
    judgementPerImage: "/hoya/v3/monitor/:id/analytics/judgement_per_image",
  },
};
